import {
  SAVE,
  VALUE_CHANGED,
  LOAD,
  RESET,
  RESET_GIVE_PERMISSION_STATE, SET_DEFAULT_VALUE,
  FETCH_EXCHANGE_RATES,
  FETCH_EXCHANGE_RATES_SUCCESS,
  FETCH_EXCHANGE_RATES_ERROR,
} from './constants';

export function saveFormData(form) {
  return {
    type: SAVE,
    payload: form,
  };
}

export function loadFormData(form) {
  return {
    type: LOAD,
    payload: form,
  };
}

export function handleFormDataChange(propertyName, value) {
  return {
    type: VALUE_CHANGED,
    propertyName,
    value,
  };
}

export function resetFormData() {
  return {
    type: RESET,
  };
}

export function resetFormGivePermissionState() {
  return {
    type: RESET_GIVE_PERMISSION_STATE,
  };
}
export function setDefaultValue(propertyName, value) {
  return {
    type: SET_DEFAULT_VALUE,
    propertyName,
    value,
  };
}

export function fetchExchangeRates(expenses) {
  return {
    type: FETCH_EXCHANGE_RATES,
    expenses,
  };
}

export function fetchExchangeRatesSuccess(rates) {
  return {
    type: FETCH_EXCHANGE_RATES_SUCCESS,
    rates,
  };
}

export function fetchExchangeRatesError(error) {
  return {
    type: FETCH_EXCHANGE_RATES_ERROR,
    error,
  };
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepClaimSummary/actions.js